import React, { useMemo } from 'react'
import { connect } from 'react-redux'
import Group from 'components/utils/Group'
import LineUsersAltIcon from 'LuxKit/Icons/line/LineUsersAltIcon'
import LineBedIcon from 'LuxKit/Icons/line/LineBedIcon'
import AssistChip from 'LuxKit/Chips/AssistChip'
import { useMultiRoomDisabledChipTravellerInit } from 'businessTraveller/hooks/useMultiRoomDisabledChipTravellerInit'

interface MappedStateProps {
  businessAccount?: App.BusinessTraveller.CurrentBusinessAccount
}

interface Props {
  className?: string
}

function BusinessTravellerSelectHotelsOfferPageMobileDisabled(props: Props & MappedStateProps) {
  const {
    className,
    businessAccount,
  } = props

  useMultiRoomDisabledChipTravellerInit(businessAccount)

  const travellerLabel = useMemo(() => {
    if (!businessAccount?.employee) {
      return '1 adult'
    }
    const { firstName = '', lastName = '' } = businessAccount.employee
    const name = `${firstName} ${lastName}`.trim()
    return name || '1 adult'
  }, [businessAccount?.employee])

  return (
    <Group className={className} direction="horizontal" gap={8} wrap="wrap">
      <AssistChip
        data-testid="multi-room-travellers-select"
        variant="outline"
        size="medium"
        startIcon={<LineUsersAltIcon />}
        disabled
      >
        {travellerLabel}
      </AssistChip>
      <AssistChip
        data-testid="multi-room-rooms-select"
        variant="outline"
        size="medium"
        startIcon={<LineBedIcon />}
        disabled
      >
        1 room
      </AssistChip>
    </Group>
  )
}

export default connect<MappedStateProps, {}, Props, App.State>((state) => {
  return {
    businessAccount: state.businessTraveller.currentBusinessAccount,
  }
})(BusinessTravellerSelectHotelsOfferPageMobileDisabled)
